import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';
import { useFormContext } from 'react-hook-form';

type MasterPatternFieldsProps = {
  path: IndicatorIndexedPath;
};

export const MasterPatternFields: FC<MasterPatternFieldsProps> = ({ path }) => {
  const { watch } = useFormContext();

  const showValueLines = watch(`${path}.show_all_value_lines`);

  return (
    <>
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.deviationThreshold`}
        label="Deviation Threshold"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.depth`}
        label="Depth"
      />
      <TradingFormField
        type="checkbox"
        name={`${path}.allow_repainting`}
        label="Allow repainting"
      />
      <TradingFormField
        type="checkbox"
        name={`${path}.show_all_value_lines`}
        label="Show all value lines"
        checked={showValueLines}
      />
      <TradingFormField
        type="numeric"
        name={`${path}.value_expiration_diff`}
        label="Value expiration threshold"
      />
    </>
  );
};
